/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
/* eslint valid-typeof: "error" */
import PropTypes from 'prop-types';
import { useState } from 'react';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Table,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  TableHead,
  TableSortLabel,
  FormControlLabel,
  Switch,
  Skeleton
} from '@material-ui/core';

// // redux
import useSettings from 'src/hooks/useSettings';
import { useDispatch, useSelector } from 'src/redux/store';
import Scrollbar from 'src/components/Scrollbar';
import Label from 'src/components/Label';
import SearchNotFound from 'src/components/SearchNotFound';
import { Box } from '@material-ui/system';
import { visuallyHidden } from '@material-ui/utils';
import TableListToolbar from './TableListToolbar';
import MouseOverPopover from '../common-components/MouseOverPopover';
// -----------------------------------------------------,
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  // if (query) {
  //   return filter(array, (_user) => _user.client_name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  // }
  return stabilizedThis.map((el) => el[0]);
}

TableSearch.propTypes = {
  tableHead: PropTypes.array,
  tableData: PropTypes.array,
  handleDelete: PropTypes.func,
  handleEdit: PropTypes.func,
  filterComponent: PropTypes.func,
  handleDisable: PropTypes.func,
  handleRestore: PropTypes.func,
  status: PropTypes.bool,
  showSearch: PropTypes.bool
};

export default function TableSearch({
  tableHead,
  tableData,
  handleDelete = () => {},
  handleEdit = () => {},
  filterComponent = () => {},
  handleDisable = () => {},
  handleRestore = () => {},
  status,
  showSearch = true,
  switchButton = false,
  switchButtonResponse = () => {},
  loading = false
}) {
  const { themeStretch } = useSettings();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dense, setDense] = useState(false);

  const stylesSheelt = {
    background: '#eeeeee',
    color: theme.palette.primary.main,
    boxShadow: 'none',
    fontSize: '0.78rem',
    fontWeight: '600',
    minWidth: '55px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#eeeeee'
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    dispatch(filterComponent(status, event.target.value));
    setFilterName(event.target.value);
  };

  const createSortHandler = (property) => (event) => {
    if (property !== 'action') {
      handleRequestSort(event, property);
    }
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

  const filterList = applySortFilter(tableData, getComparator(order, orderBy), filterName);

  const isUserNotFound = filterList.length === 0;

  const statusCol = (type, value) => {
    switch (type) {
      case 'clients':
        return value[0] ? <MouseOverPopover data={value} title="client_name" /> : '';
      case 'projects':
        return value[0] ? <MouseOverPopover data={value} title="project_name" /> : '';
      case 'required_columns':
        return <Label>{value}</Label>;
      default:
        return value;
    }
  };
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'}>
      {/* <Card> */}
      {showSearch && (
        <TableListToolbar
          numSelected={selected.length}
          filterName={filterName}
          onFilterName={handleFilterByName}
          switchButton={switchButton}
          switchButtonResponse={switchButtonResponse}
          status={status}
        />
      )}
      <Scrollbar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table
            sx={{
              '& .MuiTableCell-root:first-child': {
                borderTopLeftRadius: '8px',
                borderBottomLeftRadius: '8px',
                boxShadow: `inset 8px 0 0 ${theme.palette.mode === 'light' ? '#fff' : '#212b36'}`
              },
              '& .MuiTableCell-root:last-child': {
                borderTopRightRadius: '8px',
                borderBottomRightRadius: '8px',
                boxShadow: `inset -8px 0 0 ${theme.palette.mode === 'light' ? '#fff' : '#212b36'}`
              }
            }}
            size={dense ? 'small' : 'medium'}
          >
            <TableHead>
              <TableRow>
                {tableHead?.map((headCell, index) => (
                  <TableCell
                    key={index}
                    align={headCell.alignRight ? 'right' : 'left'}
                    sortDirection={orderBy === headCell.id ? order : false}
                  >
                    <TableSortLabel
                      hideSortIcon
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : 'asc'}
                      onClick={createSortHandler(headCell.id)}
                    >
                      {headCell.label}
                      {orderBy === headCell.id ? (
                        <Box sx={{ ...visuallyHidden }}>
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  </TableCell>
                ))}
                <TableCell />
                <TableCell />
              </TableRow>
            </TableHead>
            {!loading ? (
              <TableBody>
                {filterList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data) => (
                  <TableRow hover key={data.id} selected={false}>
                    {tableHead[0] && <TableCell align="left">{data[tableHead[0].key]}</TableCell>}
                    {tableHead[1] && <TableCell>{statusCol(tableHead[1].id, data[tableHead[1].key])}</TableCell>}
                    {tableHead[2] && <TableCell>{statusCol(tableHead[2].id, data[tableHead[2].key])}</TableCell>}
                    {tableHead[3] && <TableCell>{statusCol(tableHead[3].id, data[tableHead[3].key])}</TableCell>}
                    {tableHead[4] && <TableCell>{statusCol(tableHead[4].id, data[tableHead[4].key])}</TableCell>}
                    {tableHead[5] && <TableCell>{statusCol(tableHead[5].id, data[tableHead[5].key])}</TableCell>}
                    <TableCell>
                      <Button
                        onClick={() => (status ? handleEdit(data.id) : handleRestore(data.id))}
                        size="small"
                        variant="contained"
                        sx={stylesSheelt}
                      >
                        {status ? 'Edit' : 'Restore'}
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() => (status ? handleDisable(data.id) : handleDelete(data.id))}
                        size="small"
                        variant="contained"
                        sx={stylesSheelt}
                      >
                        {status ? 'Disable' : 'Delete'}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            ) : (
              <TableBody>
                {Array(rowsPerPage)
                  .fill('')
                  .map((data, i) => (
                    <TableRow key={i} selected={false}>
                      {tableHead[0] && (
                        <TableCell align="left">
                          <Skeleton sx={{ fontSize: '1.5rem' }} />
                        </TableCell>
                      )}
                      {tableHead[1] && (
                        <TableCell>
                          <Skeleton sx={{ fontSize: '1.5rem' }} />
                        </TableCell>
                      )}
                      {tableHead[2] && (
                        <TableCell>
                          <Skeleton sx={{ fontSize: '1.5rem' }} />
                        </TableCell>
                      )}
                      {tableHead[3] && (
                        <TableCell>
                          <Skeleton sx={{ fontSize: '1.5rem' }} />
                        </TableCell>
                      )}
                      {tableHead[4] && (
                        <TableCell>
                          <Skeleton sx={{ fontSize: '1.5rem' }} />
                        </TableCell>
                      )}
                      {tableHead[5] && (
                        <TableCell>
                          <Skeleton sx={{ fontSize: '1.5rem' }} />
                        </TableCell>
                      )}
                      <TableCell>
                        <Skeleton sx={{ fontSize: '1.5rem' }} />
                      </TableCell>
                      <TableCell>
                        <Skeleton sx={{ fontSize: '1.5rem' }} />
                      </TableCell>
                    </TableRow>
                  ))}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            )}
            {isUserNotFound && !loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={filterName} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Scrollbar>
      <Box sx={{ position: 'relative' }}>
        <TablePagination
          component="div"
          count={tableData?.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
        <Box
          sx={{
            px: 3,
            py: 1.5,
            top: 0,
            position: { md: 'absolute' }
          }}
        >
          <FormControlLabel control={<Switch checked={dense} onChange={handleChangeDense} />} label="Dense padding" />
        </Box>
      </Box>
      {/* </Card> */}
    </Container>
  );
}
